import { render, staticRenderFns } from "./PlacePtsInput.vue?vue&type=template&id=2b9b6bd3&scoped=true"
import script from "./PlacePtsInput.vue?vue&type=script&lang=js"
export * from "./PlacePtsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9b6bd3",
  null
  
)

export default component.exports